<!-- <div *ngIf="type == 'sfc-dashboard-client'">
    <app-sfc-dashboard-client></app-sfc-dashboard-client>
</div>
<div *ngIf="type == 'sfc-dashboard-service'">
    <app-sfc-dashboard-service></app-sfc-dashboard-service>
</div>
<div *ngIf="type == 'sfc-dashboard-admin'">
    <app-sfc-dashboard-admin></app-sfc-dashboard-admin>
</div>

<div *ngIf="type != 'sfc-dashboard-client' && type != 'sfc-dashboard-service' && type != 'sfc-dashboard-admin'">
    NOOOOOOO!!!!!!!!!!!
</div> -->

    NOOOOOOO!!!!!!!!!!!
